import React, { useState, useEffect } from 'react';
import TR from './../../Trans';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import ThemeToggleButton from './../items/ThemeToggleButton';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import muvikaAttrs from './../../attrs';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as EqualizerIcon } from './../../assets/equalizer.svg';
import Menu from '@mui/material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import AccountCircle from '@mui/icons-material/AccountCircle';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay';
import SearchIcon from '@mui/icons-material/Search';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import QueueMusicIcon from '@mui/icons-material/QueueMusic';
import MenuIcon from '@mui/icons-material/Menu';
import navigationStore from './../../stores/navigation';
import { LightMode, DarkMode } from "@mui/icons-material";
import { useLocalStorage } from '../../services/useLocalStorage';
import FeedbackIcon from '@mui/icons-material/Feedback';
import Badge from '@mui/material/Badge';
import PersonIcon from '@mui/icons-material/Person';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import settingsStore from '../../stores/settings';
import GradeIcon from '@mui/icons-material/Grade';
import AlbumIcon from '@mui/icons-material/Album';
import MicIcon from '@mui/icons-material/Mic';
import SettingsIcon from '@mui/icons-material/Settings';
import { Views } from './../../enums/enums';
import ListItemIcon from '@mui/material/ListItemIcon';
import version from './../../version';
import sessionStore from './../../stores/session';
import musicPlayerStore from '../../stores/musicPlayer';
import playerStore from '../../stores/player';
import accountStore from '../../stores/account';
import songbookQueueStore from '../../stores/songbookQueue';

function BottomBar() {

  const sessionToken = sessionStore((state) => state.sessionToken);
  const account = accountStore((state) => state.account);
  const logout = sessionStore((state) => state.logout);
  const goToView = navigationStore((state) => state.goToView);
  const settings = settingsStore((state) => state.settings);
  const currentView = navigationStore((state) => state.currentView);
  const safeArea = navigationStore((state) => state.safeArea);
  const getSettings = settingsStore((state) => state.getSettings);
  const isMusicPlaying = musicPlayerStore((state) => state.isPlaying);
  const isPlayerStopped = playerStore((state) => state.isStopped);
  const setSettings = settingsStore((state) => state.setSettings);
  const isSettingsWaiting = settingsStore((state) => state.isWaiting);
  const queue = songbookQueueStore((state) => state.queue);

  const [theme, setTheme] = useLocalStorage(muvikaAttrs.service + "-theme", "dark");

  const [anchorEl, setAnchorEl] = useState(null);
  const [isBottomBarMenuOpen, setBottomBarMenuOpen] = useState(false);
  const [isBgMusicOn, setIsBgMusicOn] = useState(false);

  useEffect(() => {
    if (!settings) {
      getSettings(sessionToken);
    }
  }, []);

  const handleBottomBarMenuClose = () => {
    setBottomBarMenuOpen(false);
  };

  const openBottomBarMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setBottomBarMenuOpen(true);
  };

  const renderNewLink = () => {
    return <MenuItem selected={currentView == Views.NewTracks} onClick={() => {
      handleBottomBarMenuClose();
      goToView(Views.NewTracks);
    }}>
      <ListItemIcon>
        <FiberNewIcon />
      </ListItemIcon>
      <ListItemText primary={TR.cm_new} />
    </MenuItem>;
  };

  const renderSingersLink = () => {
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        return <MenuItem selected={currentView == Views.Singers} onClick={() => {
          handleBottomBarMenuClose();
          goToView(Views.Singers);
        }}>
          <ListItemIcon>
            <MicIcon />
          </ListItemIcon>
          <ListItemText primary={TR.cm_singers} />
        </MenuItem>;
      }
    }
  };

  const renderFavoritesLink = () => {
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        return <MenuItem selected={currentView == Views.Favorites} onClick={() => {
          handleBottomBarMenuClose();
          goToView(Views.Favorites);
        }}>
          <ListItemIcon>
            <GradeIcon />
          </ListItemIcon>
          <ListItemText primary={TR.cm_favorites} />
        </MenuItem>;
      }
    }
  };

  const renderBgExpand = () => {
    if (isBgMusicOn) {
      return <ExpandLessIcon />;
    } else {
      return <ExpandMoreIcon />;
    }
  };

  const showMusicIcon = () => {
    if (isMusicPlaying.isPlaying && isPlayerStopped.isStopped) {
      //return <SvgIcon component={EqualizerIcon} />;
    }
    return <AlbumIcon />;
  };

  const renderMusicLink = () => {
    return <MenuItem onClick={() => {
      if (isBgMusicOn) {
        setIsBgMusicOn(false);
      } else {
        setIsBgMusicOn(true);
      }
    }} selected={currentView == Views.BackgroundMusic}>
      <ListItemIcon>
        {showMusicIcon()}
      </ListItemIcon>
      <ListItemText primary={TR.cm_background_music} />
      {renderBgExpand()}
    </MenuItem>;
  };

  const renderMusicPlayerLink = () => {
    return <MenuItem onClick={() => {
      handleBottomBarMenuClose();
      goToView(Views.BackgroundMusicPlayer);
    }} selected={currentView == Views.BackgroundMusicPlayer}>
      <ListItemIcon>
        <QueueMusicIcon />
      </ListItemIcon>
      <ListItemText primary={TR.cm_bg_player} />
    </MenuItem>;
  };

  const renderMusicStylesLink = () => {
    return <MenuItem onClick={() => {
      handleBottomBarMenuClose();
      goToView(Views.BackgroundMusicStyles);
    }} selected={currentView == Views.BackgroundMusicStyles}>
      <ListItemIcon>
        <MusicNoteIcon />
      </ListItemIcon>
      <ListItemText primary={TR.cm_bg_styles} />
    </MenuItem>;
  };

  const renderMusicSearchLink = () => {
    return <MenuItem onClick={() => {
      handleBottomBarMenuClose();
      goToView(Views.BackgroundMusicSearch);
    }} selected={currentView == Views.BackgroundMusicSearch}>
      <ListItemIcon>
        <SearchIcon />
      </ListItemIcon>
      <ListItemText primary={TR.cm_search} />
    </MenuItem>;
  };

  const renderMusicPlaylistsLink = () => {
    return <MenuItem onClick={() => {
      handleBottomBarMenuClose();
      goToView(Views.BackgroundMusicPlaylists);
    }} selected={currentView == Views.BackgroundMusicPlaylists}>
      <ListItemIcon>
        <PlaylistPlayIcon />
      </ListItemIcon>
      <ListItemText primary={TR.cm_playlists} />
    </MenuItem>;
  };

  const renderMusicSublist = () => {
    if (isBgMusicOn) {
      return <List className="muvika-sidebar-sublist">
        {renderMusicPlayerLink()}
        {renderMusicStylesLink()}
        {renderMusicSearchLink()}
        {renderMusicPlaylistsLink()}
      </List>;
    }
  };

  const renderAccountLink = () => {
    return <MenuItem selected={currentView == Views.Account} onClick={() => {
      handleBottomBarMenuClose();
      goToView(Views.Account);
    }}>
      <ListItemIcon>
        <AccountCircle />
      </ListItemIcon>
      <ListItemText primary={TR.ww_your_account_information} />
    </MenuItem>;
  };

  const renderSettingsLink = () => {
    return <MenuItem selected={currentView == Views.Settings} onClick={() => {
      handleBottomBarMenuClose();
      goToView(Views.Settings);
    }}>
      <ListItemIcon>
        <SettingsIcon />
      </ListItemIcon>
      <ListItemText primary={TR.cm_settings} />
    </MenuItem>;
  };

  const renderFeedbackLink = () => {
    return <MenuItem selected={currentView == Views.Feedback} onClick={() => {
      handleBottomBarMenuClose();
      goToView(Views.Feedback);
    }}>
      <ListItemIcon>
        <FeedbackIcon />
      </ListItemIcon>
      <ListItemText primary={TR.cm_feedback} />
    </MenuItem>;
  };

  const renderSongbookQueueLink = () => {
    if (account) {
      if (!account.tags.includes("consumer")) {
        return <Badge className="muvika-sidebar-badge" badgeContent={queue?.length} color="primary">
          <MenuItem onClick={() => {
            handleBottomBarMenuClose();
            goToView(Views.SongbookQueue);
          }} selected={currentView == Views.SongbookQueue}>
            <ListItemIcon>
              <PlaylistAddCheckIcon />
            </ListItemIcon>
            <ListItemText primary={TR.cm_songbook_queue} />
          </MenuItem>
        </Badge>;
      }
    }
  };

  const renderVersion = () => {
    if (settings) {
      if (settings.usage_mode === "booth") {
        return <MenuItem className="muvika-version-number">
          <small>{version} {TR.cm_booth_mode} {muvikaAttrs.side === "dev" ? "no_rep" : ""}</small>
        </MenuItem>;
      }
    }
    return <MenuItem className="muvika-version-number">
      <small>{version} {muvikaAttrs.side === "dev" ? "no_rep" : ""}</small>
    </MenuItem>;
  };

  const toggleTheme = () => {
    if (settings) {
      let newSettings = { ...settingsStore.getState().settings };
      if (settings.theme === "light") {
        document.documentElement.classList.remove("light-theme");
        setTheme("dark");
        newSettings.theme = "dark";
      } else {
        document.documentElement.classList.add("light-theme");
        setTheme("light");
        newSettings.theme = "light";
      }
      setSettings(sessionToken, newSettings, false, true);
      handleBottomBarMenuClose();
    }
  };

  const renderThemeLink = () => {
    if (settings) {
      if (settings.theme === "dark") {
        return <MenuItem disabled={isSettingsWaiting} onClick={() => toggleTheme()}>
          <ListItemIcon>
            <LightMode />
          </ListItemIcon>
          <ListItemText primary={TR.cm_set_light_theme} />
        </MenuItem>;
      } else {
        return <MenuItem disabled={isSettingsWaiting} onClick={() => toggleTheme()}>
          <ListItemIcon>
            <DarkMode />
          </ListItemIcon>
          <ListItemText primary={TR.cm_set_dark_theme} />
        </MenuItem>;
      }
    }
  };

  return (
    <div id="muvika-bottom-bar">
      <Paper id="muvika-bottom-bar-paper" className="muvika-bottom-bar-paper" elevation={10} sx={{
        paddingBottom: safeArea ? safeArea.bottom + "px" : 0,
        paddingLeft: safeArea ? safeArea.left + "px" : 0,
        paddingRight: safeArea ? safeArea.right + "px" : 0
      }}>
        <BottomNavigation
          showLabels
          className="muvika-bottom-bar-nav"
        >
          <BottomNavigationAction className={currentView == Views.Home ? "Mui-selected" : ""} label={TR.cm_home} icon={<HomeIcon />} onClick={() => goToView(Views.Home)} />
          <BottomNavigationAction className={currentView == Views.Catalog ? "Mui-selected" : ""} label={TR.cm_browse} icon={<MusicNoteIcon />} onClick={() => goToView(Views.Catalog)} />
          <BottomNavigationAction className={currentView == Views.Search ? "Mui-selected" : ""} label={TR.cm_search} icon={<SearchIcon />} onClick={() => goToView(Views.Search)} />
          <BottomNavigationAction className={currentView == Views.PlayLists ? "Mui-selected" : ""} label={TR.cm_playlists} icon={<PlaylistPlayIcon />} onClick={() => goToView(Views.PlayLists)} />
          <BottomNavigationAction icon={<MenuIcon />} label={TR.cm_more} onClick={openBottomBarMenu} />
        </BottomNavigation>
      </Paper>
      <Menu disableAutoFocus disableEnforceFocus disableRestoreFocus
        id={"menu-bottombar"}
        className="muvika-bottom-bar-menu"
        sx={{
          marginTop: safeArea ? "calc(" + -safeArea.bottom + "px - 2.4rem)" : "-2.4rem",
          marginLeft: safeArea ? (-safeArea.right) + "px" : "-0.94rem"
        }}
        open={isBottomBarMenuOpen}
        anchorEl={anchorEl}
        onClose={handleBottomBarMenuClose}
        MenuListProps={{
          'aria-labelledby': "menu-bottombar",
        }}
      >
        <List className="muvika-menu-list">
          {renderNewLink()}
          {renderSingersLink()}
          {renderFavoritesLink()}
        </List>
        <List className="muvika-menu-list">
          {renderAccountLink()}
          {renderSettingsLink()}
          {renderFeedbackLink()}
        </List>
        <List className="muvika-menu-list">
          {/* {renderMusicLink()} */}
          {renderSongbookQueueLink()}
          {renderMusicLink()}
          {renderMusicSublist()}
          {renderThemeLink()}
        </List>
        {renderVersion()}
      </Menu>
    </div>
  );
}

export default BottomBar;